// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToolTip_wrapper__rzMl3","tooltip":"ToolTip_tooltip__2Ijtj","left":"ToolTip_left__2DsnT","right":"ToolTip_right__2vi8B","anchor":"ToolTip_anchor__3r3iO"};